import equalByNameAndAssetComponentId from '../../utils/equalByNameAndAssetComponentId';
import {i18n} from "../../../vue-i18n";

export default class SetManualChart {
  constructor(assetComponentName, newManualCharts) {
    this.commandName = "SetManualChart";

    this.assetComponentName = assetComponentName;
    this.newManualCharts = newManualCharts;

    this.description =
      `${i18n.t ('CONTENT.events.for_component')} ${this.assetComponentName} ${i18n.t('CONTENT.events.added_new_manualCharts')}`;
  }

  // Use this method to push this command to the server
  serialize() {
    return {
      commandName: this.commandName,
      serialisedCommand: this.newManualCharts.serialisedCommand
    }
  }

  equal = (other) => equalByNameAndAssetComponentId(this, other);
}
